export default __webpack_public_path__ + "media/images/dashboard_icons/magic_wand-74166b7bcd60e8905128ab43ecd1e8a4.svg";